import { REVISION } from "three";
const version = /* @__PURE__ */(() => parseInt(REVISION.replace(/\D+/g, "")))();
export { version };